import { render, staticRenderFns } from "./GuestChats.vue?vue&type=template&id=3b3096d2&scoped=true"
import script from "./GuestChats.vue?vue&type=script&lang=js"
export * from "./GuestChats.vue?vue&type=script&lang=js"
import style0 from "./GuestChats.vue?vue&type=style&index=0&id=3b3096d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3096d2",
  null
  
)

export default component.exports